import { css } from 'styled-system/css';

export const newbieModalStyle = {
	content: css({
		_mars: {
			height: '375px',
			animation: 'newbie-modal-show .5s ease forwards',
		},
	}),
	iframe: css({
		_mars: {
			backgroundColor: 'home.bg',
			height: '100%',
		},
	}),
}